import {
  abRollerPI,
  waterBottlePI,
  legPressPI,
  pecDeckPI,
  platesPI,
  squatRackPI,
  jumpRopePI,
  latPulldownPI,
  dumbbellPI,
  onPI,
  mbPI,
  matPI,
  kettlebellPI,
  betaAlPI,
  bcaaPI,
  dumbbellsSetPI,
} from "../../images/index";
/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7501",
    title: "ON Protien",
    description: "100% Whey Protein.",
    categoryName: "supplements",
    price: 3049,
    inStock: true,
    isDeliveredFast: true,
    isTrending: true,
    rating: 4,
    image: onPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7502",
    title: "Aurion Hex Dumbbells",
    description: "Rubber Coated.",
    categoryName: "weights",
    price: 1100,
    inStock: true,
    isDeliveredFast: false,
    isTrending: true,
    rating: 2,
    image: dumbbellPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7503",
    title: "Leg Press",
    description: "Best suited for leg exercises.",
    categoryName: "equipments",
    price: 7499,
    inStock: false,
    isDeliveredFast: false,
    isTrending: true,
    rating: 1,
    image: legPressPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7504",
    title: "5KG Kettlebell",
    description: "Wide Rubber Grip.",
    categoryName: "weights",
    price: 799,
    inStock: true,
    isDeliveredFast: true,
    isTrending: true,
    rating: 4,
    image: kettlebellPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7505",
    title: "Skipping Rope",
    description: "Tangle Free for Kids",
    categoryName: "accessories",
    price: 199,
    inStock: true,
    isDeliveredFast: true,
    isTrending: false,
    rating: 3,
    image: jumpRopePI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7506",
    title: "BCAA Energy",
    description: "30 Serving, Lychee",
    categoryName: "supplements",
    price: 999,
    inStock: true,
    isDeliveredFast: true,
    isTrending: false,
    rating: 3,
    image: bcaaPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7507",
    title: "Weighted Plates",
    description: "Rubber coated plates",
    categoryName: "weights",
    price: 3999,
    inStock: false,
    isDeliveredFast: false,
    isTrending: false,
    rating: 1,
    image: platesPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7508",
    title: "Ab Roller",
    description: "Crush Ab exercises",
    categoryName: "accessories",
    price: 199,
    inStock: true,
    isDeliveredFast: true,
    isTrending: false,
    rating: 4,
    image: abRollerPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7509",
    title: "Pec Deck",
    description: "Best for chest exercises",
    categoryName: "equipments",
    price: 8999,
    inStock: true,
    isDeliveredFast: false,
    isTrending: false,
    rating: 5,
    image: pecDeckPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7510",
    title: "MB Whey",
    description: "Rich Chocolate Flavor",
    categoryName: "supplements",
    price: 4699,
    inStock: true,
    isDeliveredFast: true,
    isTrending: false,
    rating: 2,
    image: mbPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7511",
    title: "Squat Rack",
    description: "Best Build Quality",
    categoryName: "equipments",
    price: 7999,
    inStock: true,
    isDeliveredFast: false,
    isTrending: false,
    rating: 3,
    image: squatRackPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7512",
    title: "Dumbbells full set",
    description: "Rubber Encased Dumbbell",
    categoryName: "weights",
    price: 9580,
    inStock: true,
    isDeliveredFast: true,
    isTrending: false,
    rating: 3,
    image: dumbbellsSetPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7513",
    title: "Water Bottle",
    description: "Leakproof Sipper",
    categoryName: "accessories",
    price: 89,
    inStock: true,
    isDeliveredFast: true,
    isTrending: false,
    rating: 2,
    image: waterBottlePI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7514",
    title: "Beta Alanine ",
    description: "Amino acid supplement",
    categoryName: "supplements",
    price: 1499,
    inStock: true,
    isDeliveredFast: false,
    isTrending: false,
    rating: 1,
    image: betaAlPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7515",
    title: "MuscleX Yoga Mat",
    description: "Pure EVA Material",
    categoryName: "accessories",
    price: 149,
    inStock: false,
    isDeliveredFast: false,
    isTrending: false,
    rating: 1,
    image: matPI,
  },
  {
    _id: "c7ee18c1-d14a-4473-9bc6-1d39ca2c7516",
    title: "Lat Pull Down",
    description: "For Strength Training",
    categoryName: "equipments",
    price: 5449,
    inStock: true,
    isDeliveredFast: false,
    isTrending: false,
    rating: 4,
    image: latPulldownPI,
  },
];
